type TravelerReason = {
  title: string
  href: string
}

const travelerReasons: TravelerReason[] = [
  {
    title: 'Always On Time',
    href: '#',
  },
  {
    title: 'Professional Drivers',
    href: '#',
  },
  {
    title: 'Modern Fleet',
    href: '#',
  },
  {
    title: 'Transparent Pricing',
    href: '#',
  },
  {
    title: 'Flexible Travel',
    href: '#',
  },
  {
    title: 'Customer-First Service',
    href: '#',
  },
]

export default function WhyTravelers() {
  return (
    <section className="w-full bg-white px-5 py-16 sm:px-8 lg:py-[90px]">
      <div className="mx-auto grid w-full max-w-[1180px] items-center gap-12 lg:grid-cols-[1fr_0.96fr] lg:gap-[70px]">
       
        <div className="overflow-hidden rounded-[30px]">
          <img
            src="/assets/images/image 260.png"
            alt="Beautiful street view in Salzburg"
            className="h-[340px] w-full object-cover sm:h-[430px] lg:h-[470px]"
          />
        </div>

        
        <div className="w-full">
          <h2 className="font-host text-[24px] font-semibold leading-tight tracking-[-0.025em] text-[#5E7F20] sm:text-[27px]">
            Why Travelers Choose Us
          </h2>

          <div className="mt-7">
            {travelerReasons.map((reason) => (
              <a
                key={reason.title}
                href={reason.href}
                className="group flex min-h-[62px] items-center justify-between gap-4 border-b border-[#D8D8D8] font-poppins"
              >
                <span className="text-[15px] font-medium tracking-[-0.015em] text-black sm:text-[16px]">
                  {reason.title}
                </span>

               {/* <span className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-full border border-[#E1E1E1] bg-green shadow-[0_2px_6px_rgba(0,0,0,0.08)]"> */}
                    <img
                        src="/assets/images/green-tick.png"
                        alt=""
                        className="h-[22px] w-[22px] object-contain"
                    />
                {/* </span> */}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}